import React, { FC, memo, useCallback, useState } from "react";
import SortIcon from "@mui/icons-material/Sort";
import IconButton from "@mui/material/IconButton";
import { SortState } from "./types";

interface GenDataSortButtonProps {
  state?: SortState;
  onClick: (state: SortState) => void;
}

const toggleState = (state: SortState): SortState => {
  switch (state) {
    case SortState.default:
      return SortState.asc;
    case SortState.desc:
      return SortState.default;
    case SortState.asc:
      return SortState.desc;
    default:
      return SortState.default;
  }
};

const GenDataSortButton: FC<GenDataSortButtonProps> = (props) => {
  const { state, onClick } = props;
  const [sortState, setSortState] = useState(state || SortState.default);

  const handleOnClick = useCallback(() => {
    const newState = toggleState(sortState);
    onClick(newState);
    setSortState(newState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onClick]);

  return (
    <IconButton onClick={handleOnClick}>
      <SortIcon
        color={sortState === SortState.default ? "secondary" : "primary"}
        sx={{
          transform:
            sortState === SortState.asc
              ? "rotate(180deg)"
              : sortState === SortState.desc
              ? "rotate(360deg)"
              : "none",
        }}
      />
    </IconButton>
  );
};

export default memo(GenDataSortButton);
